<div mat-dialog-container
     class="import-modal-container"
     id="import-container">

  <button class="back-button"
          (click)="closeModal()">
    <i class="far fa-arrow-circle-left"></i>
    <div class="back-text"
         translate="MODAL.BACK_IMPORT"></div>
  </button>


  <div class="dialog-title"
       translate="MODAL.TEMPLATE">
    <span class="import-subtitle">VIA {{ currentEstimate.projectModelCode }}</span>
  </div>

  <h2 class="import-header">
    <span>{{ settings?.level1Label }}</span>
    <span>{{ settings?.level2Label }}</span>
  </h2>

  <div mat-dialog-content
       class="import-dialog"
       style="overflow: hidden">


    <p-treeTable [value]="importTree"
                 [scrollable]="true"
                 scrollHeight="flex">
      <ng-template pTemplate="header"
                   let-columns> </ng-template>
      <ng-template pTemplate="body"
                   let-rowData="rowData"
                   let-rowNode
                   let-columns="columns">
        <tr>
          <td [ngClass]="{
              'import-node': rowNode.node.type === 'project',
              'level1-import-node': rowNode.node.type === 'level1',
              'level2-import-node': rowNode.node.type === 'level2'
            }">

            <label>
              <input type="checkbox"
                     (change)="onSelect($event, rowNode.node)"
                     [(ngModel)]="rowNode.node.isChecked" />
              <span class="import-label">{{ rowNode.node.label }}</span>
            </label>
          </td>
        </tr>
      </ng-template>
    </p-treeTable>

  </div>

  <div class="btn-container">
    <button class="save-btn"
            style="margin-right: 1em"
            [ngClass]="{ disabled: selectedNodes.length === 0 }"
            (click)="importTemplates()"
            translate="MODAL.TEMPLATE"></button>
    <button class="cancel-btn"
            (click)="closeModal()"
            translate="BUTTON.CANCEL"></button>
  </div>
</div>
